import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import deleteImg from "../../../../../picture/delete.png";
import reloadImg from "../../../../../picture/timer-language.png";
import { useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import WarningModal from "../../WarningModal";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  smallCell: {
    width: "40px",
    textAlign: "center",
    cursor: "pointer"
  },
  icon: {
    width: "30px",
    height: "30px"
  }
};

function ArhiviranaTabela({
  dokumenta,
  moveToVazeci,
  handleDelete,
  checkedRows,
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll
}) {
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: ""
  });

  const [deleteData, setDeleteData] = useState({
    documentId: "",
    documentType: ""
  });

  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);

  const { dictionary } = useGlobalContext();

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType }
    );
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };

  const handleCheckAll = () => {
    if (isCheckedAll) {
      setCheckedRows([]);
    } else {
      setCheckedRows(dokumenta.map((z) => z.id));
    }
    setIsCheckedAll((prev) => !prev);
  };

  const isDeleteOneVersion = deleteData.documentId && deleteData.documentType;

  const handleOpenDelete = (id) => {
    if (selectedField.documentId === id && selectedField.documentType) {
      const postojeciDokument = dokumenta.find((d) => d.id === id);
      if (postojeciDokument[selectedField.documentType] === "") {
        setIsOpenWarningModal(true);
        return;
      }
      setDeleteData(selectedField);
      return;
    }
    setDeleteData({ documentId: id, documentType: "" });
  };

  const handleConfirmDelete = () => {
    if (isDeleteOneVersion) {
      handleDelete(deleteData.documentId, deleteData.documentType);
    } else {
      handleDelete(deleteData.documentId);
    }
    setDeleteData({ documentId: "", documentType: "" });
  };

  const handleCancelDelete = () => {
    setDeleteData({ documentId: "", documentType: "" });
  };

  return (
    <>
      <table style={{ width: "100%", marginTop: "30px" }}>
        <tr>
          <th style={styles.smallCell}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={styles.smallCell}>
            <img src={wordImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={pdfImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={imageImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={scanImg} style={{ width: "30px" }} />
          </th>
          <th style={{ fontWeight: "bold", fontSize: "1.7em", ...styles.cell }}>{dictionary["arhiviranaDokumenta"]}</th>
          <th style={{ fontWeight: "bold", fontSize: "1.7em", ...styles.cell }}>{dictionary["dodato"]}</th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
        </tr>
        {dokumenta.map((dokument) => (
          <tr key={dokument.id}>
            <td style={styles.cell}>
              <input
                type="checkbox"
                checked={checkedRows.includes(dokument.id)}
                onChange={() => handleCheckRow(dokument.id)}
                style={{ width: "30px" }}
              />
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "word")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "word"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.word,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "pdf")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "pdf"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.pdf,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "image")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "image"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.image,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "scan")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "scan"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.scan,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td style={{ textAlign: "start", fontSize: "1.5em", fontWeight: "bold", padding: "5px" }}>{dokument.nazivDokumenta}</td>
            <td style={{ fontSize: "1.5em", fontWeight: "bold", ...styles.cell }}>{dokument.datum}</td>
            <td style={styles.smallCell}>
              <img src={visibleImg} style={{ width: "30px" }} />
            </td>
            <td style={styles.smallCell}>
              <img src={downloadImg} style={{ width: "25px" }} />
            </td>
            <td
              onClick={() => handleOpenDelete(dokument.id)}
              style={styles.smallCell}
            >
              <img src={deleteImg} style={{ width: "25px" }} />
            </td>
            <td onClick={() => moveToVazeci(dokument)} style={styles.smallCell}>
              <img src={reloadImg} style={{ width: "25px" }} />
            </td>
          </tr>
        ))}
      </table>

      {deleteData.documentId && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={
            isDeleteOneVersion
              ? `Da li ste sigurni da zelite da obrisete ${deleteData.documentType} verziju dokumenta?`
              : dictionary["confirmDeleteDocumentAllVersions"]
          }
          handleCancel={handleCancelDelete}
        />
      )}

      {isOpenWarningModal && (
        <WarningModal
          text={dictionary["nepostojecaVerzija"]}
          handleCancel={() => setIsOpenWarningModal(false)}
        />
      )}
    </>
  );
}

export default ArhiviranaTabela;